import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-down"} maskId="square-filled-radius-0-stroke-1-IconArrowDown"><path fillRule="evenodd" clipRule="evenodd" d="M13.0002 3V17.5858L18.0001 12.5858L19.4144 14L12.0002 21.4142L4.58594 14L6.00015 12.5858L11.0002 17.5858V3H13.0002Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowDown;
